import React, { useEffect, useState } from 'react';
import backArrow from '../../../assets/icons/back-arrow.png';
import { useUserContext } from '../../../contexts/UserContext.js';
import axios from 'axios';
import Spinner from '../../Spinner.js';
import moment from 'moment-timezone';
import Switch from "react-switch";
import { useFiresContext } from '../../../contexts/FiresContext.js';
import FlatList from 'flatlist-react/lib';
import TeamFireCard from './TeamFireCard.js';
import { UsersThree, SignOut } from '@phosphor-icons/react';

export default function Team(props) {
    const {
        user,
        getToken
    } = useUserContext();

    const {
        team,
        setSubStage,
        setTeam,
        getTeams,
    } = props;

    const {
        setModal
    } = useFiresContext();

    const [teamAlerts, setTeamAlerts] = useState(null);
    const [stage, setStage] = useState('Fire Alerts');
    const [toggleAlerts, setToggleAlerts] = useState(team.cognito_user_ids?.some(id => id === user.accessToken.payload.sub))

    const reGetTeams = () => {
        getToken().then((token) => {
            getTeams(token);
        }).catch((err) => {
            console.log('error getting token', err);
            console.log('Trouble getting teams. Please try again.')
        })
    };

    const getTeamAlerts = () => {
       getToken().then((token) => {
        axios.get(`https://firewatch-api.space-eyes.com/user/notifications?team_id=${team.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            setTeamAlerts(res.data.alerts);
        }).catch((error) => {
            console.log('error calling alerts API: ', error);
        }) 
       }).catch((error) => {
        console.log('error getting token: ', error);
       })
    }

    const toggleAlertsButton = (value) => {
        getToken().then((token) => {
            axios.post(`https://firewatch-api.space-eyes.com/teams/email-alerts`, {
                toggle: value ? 1 : 0,
                team_id: team.id
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
            }).then((response) => {
                setTeam({...team, alert_emails: response.data.alert_emails});
                // setStage('teams')
                reGetTeams();
            }).catch((error) => {
                console.log('error calling alerts API: ', error);
            }) 
           }).catch((error) => {
            console.log('error getting token: ', error);
           })
    }

    const formatNumber = (num) => {
        if (num >= 1e9) { 
          return (num / 1e9).toFixed(1) + " billion";
        } else if (num >= 1e6) {
          return (num / 1e6).toFixed(1) + " million";
        } else {
          return num.toLocaleString();
        }
    }


    const renderFireRow = (fire) => (
        <TeamFireCard 
            key={fire.fire_id}
            fire={fire}
            team={team}
            teamAlerts={teamAlerts}
            setTeamAlerts={setTeamAlerts}
            getToken={getToken}
            user={user}
            setModal={setModal}
        />
    )

    useEffect(() => {
        getTeamAlerts();
    }, [team]);



    const stageSwitch = () => {
        switch (stage) {
            case 'Area Alerts':
                return (
                    // teamAlerts ?
                    // <div style={{ maxHeight: 200, width: '100%' }}>
                    //     {teamAlerts.filter((alert) => alert.team_id === team.id).filter((alert) => alert.area_id).slice(0, 10).map((alert) => {
                    //         return (
                    //             <div style={{ width: '100%', padding: 10, borderWidth: 1, borderColor: 'gray'}}>
                    //                 <div style={{ fontSize: 18, color: 'white' }}>{alert.id}</div>
                    //             </div>
                    //         )
                    //     })}
                    // </div>
                    // :
                    <Spinner />
                )
            case 'Fire Alerts':
                return (
                    !toggleAlerts ?
                    <></>
                    :
                    teamAlerts ?
                    <div style={{ height: '100%', width: '100%', paddingHorizontal: 12, flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '0.5rem', paddingBottom: '18rem' }}>
                        {teamAlerts.length > 0 && 
                        <div style={{ 
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.3rem',
                            marginTop: '0.5rem',
                            cursor: 'pointer',
                            padding: '0.5rem',
                            backgroundColor: 'rgba(255, 0, 0, 0.05)',
                            borderRadius: '6px',
                            borderLeft: '3px solid #dc3545'
                        }}>
                            <div style={{ 
                                fontSize: '0.8rem', 
                                color: '#dc3545', 
                                fontWeight: '600' 
                            }}>
                                Fire Alerts ({(teamAlerts.length.toLocaleString())})
                            </div>
                        </div>}
                        <FlatList
                            list={teamAlerts}
                            renderItem={renderFireRow}
                            renderOnScroll
                            renderWhenEmpty={() => <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'black', paddingTop: '0.5rem' }}>There are no fires at the moment.</div>}
                        />
                    </div>
                    :
                    <div style={{ paddingBottom: 20 }}>
                        <Spinner />
                    </div>
                )
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%', alignItems: 'flex-start', height: '100%' }}>
            <div 
                onClick={() => setSubStage('teams')}
                style={{ display: 'flex', alignItems: 'center', gap: 3, cursor: 'pointer' }}
            >
                <img src={backArrow} style={{ width: 17, height: 17, filter: 'invert(100%)'}}/>
                <div style={{ fontSize: 13, color: 'black' }}>Back</div>
            </div>
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: '0.5rem', flex: 1, width: '100%', borderWidth: 1, borderColor: 'gray', borderRadius: 10, marginTop: 10 }}>
                <div style={{ width: '100%', borderBottomWidth: 1, borderBottomColor: 'gray', borderRadius: 10 }}>
                    <img 
                        src={team.image_url} style={{  borderRadius: 10, width: '100%', height: 110 }}
                    />
                </div>
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column', flex: 1, position: 'relative', width: '100%', gap: '0.6rem' }}>
                    <div style={{ fontSize: 18, color: 'black', fontWeight: 'bold', maxWidth: '65%', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <UsersThree size={20} />
                        {team.name}
                    </div>
                    <div style={{ position: 'absolute', top: 0, right: 10 }}>
                        <div 
                            onClick={() => {
                                // Leave team functionality to be implemented
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: '0.5rem 1rem',
                                backgroundColor: 'rgba(220, 53, 69, 0.1)',
                                border: '1px solid rgba(220, 53, 69, 0.3)',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                            }}
                        >
                            <SignOut size={16} color="#dc3545" weight="bold" />
                            <div style={{ fontSize: '14px', color: '#dc3545', fontWeight: 'bold' }}>
                                Leave Team
                            </div>
                        </div>
                    </div>
                    <div style={{ 
                        marginTop: '1rem', 
                        padding: '0.5rem', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '6px', 
                        borderLeft: '3px solid #dee2e6', 
                        lineHeight: '1.4' 
                    }}>
                        <div style={{ fontSize: '0.8rem', color: 'black' }}>
                            {team.description || 'No Description'}
                        </div>
                    </div>
                    <div style={{ 
                        marginTop: '0.1rem', 
                        marginBottom: '0.4rem', 
                        padding: '0.6rem', 
                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
                        borderRadius: '8px', 
                        borderLeft: '4px solid #28a745', 
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)' 
                    }}>
                        <div style={{ 
                            fontSize: '0.75rem', 
                            color: '#6c757d', 
                            fontWeight: '500', 
                            marginBottom: '0.2rem', 
                            textTransform: 'uppercase', 
                            letterSpacing: '0.5px' 
                        }}>
                            Total Asset Value
                        </div>
                        <div style={{ 
                            fontSize: '1.1rem', 
                            color: '#28a745', 
                            fontWeight: '700', 
                            fontFamily: 'Courier New, monospace' 
                        }}>
                            ${formatNumber(Number(team.total_value))}
                        </div>
                    </div>
                    {/* <div style={{  width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly', marginBottom: 7, marginTop: 10, padding: 12 }}>
                        {['Area Alerts', 'Fire Alerts'].map((tab) => {
                            return (
                                <div 
                                    style={tab === stage ? { paddingBottom: 10, borderBottomWidth: 2, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderBottomColor: 'rgba(0, 0, 0, 0)', width: '50%', borderBottomColor: '#0080ff'} : { paddingBottom: 10, borderBottomWidth: 2, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderBottomColor: 'rgba(0, 0, 0, 0)', width: '50%' }}
                                    onPress={() => {
                                        setStage(tab)
                                    }}
                                    >
                                    <div style={tab === stage ? { textAlign: 'center', fontSize: 12, color: 'white', fontWeight: 'bold', color: '#0080ff'} :  { textAlign: 'center', fontSize: 12, color: 'white', fontWeight: 'bold' }}>
                                    {tab}
                                    </div>
                                </div>
                            )
                        })}
                    </div> */}
                    {/* {<div style={{ padding: 12, fontSize: 13, color: 'white' }}>Fire Alerts</div>} */}
                    {stageSwitch(stage)}
                </div>
            </div>
        </div>
    )
}